<template>
    <div class="address-form" style="margin: 50px auto;">
        <el-form @submit.prevent="submitAddress" :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="用户名" prop="username">
                <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="mobile">
                <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="省市区：" prop="selectedOptions">
                <el-cascader size="medium " :options="pcaTextArr" v-model="form.selectedOptions" style="width:100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
                <el-input type="textarea" placeholder="请输入详细地址" v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item prop="isdefault">
                <el-checkbox v-model="form.isdefault">是否设为默认地址</el-checkbox>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitAddress">{{ changetype!='1' ? '保存地址' : '保存并使用地址' }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script >
    import { pcaTextArr } from "element-china-area-data";
    import { addAdress, updateAdress } from "@/api/manage.js";
    export default {
        props: ['type', 'data', 'changetype'],
        data() {
            return {
                pcaTextArr,
                form: {
                    userid: JSON.parse(localStorage.getItem('user')).gid,
                    username:'',
                    mobile:'',            
                    selectedOptions: [],
                    address:'',
                    isdefault: false,
                },
                changeselectedOptions: [],
                changespecificaddress: '',
                changename: '',
                changeiphone: '',
                rules: {
                    username: [
                        { required: true, message: '请输入收货姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                    ],
                    selectedOptions:[
                        { required: true, message: '请选择省市区', trigger: 'change' },
                    ],
                    address: [
                        { required: true, message: '请输入详细地址', trigger: 'blur' }
                    ]
                },
                addresses: [],
            }
        },
        components: {

        },
        created(){
            let vm = this;
            if(vm.type == '1') {
                vm.form.username = vm.data.username;
                vm.form.mobile = vm.data.mobile;
                vm.form.address = vm.data.address;
                !vm.data.isdefault ? vm.form.isdefault = false : vm.form.isdefault = true;
                vm.form.selectedOptions = [vm.data.sheng, vm.data.shi, vm.data.qu];
                vm.form.pkid = vm.data.pkid;
            }
        },
        mounted(){
            let vm = this;
        },
        methods:{            
            submitAddress() {
                let vm = this;
                vm.$refs.form.validate(async (valid) => {
                    if (valid) {
                        let obj = Object.assign({}, vm.form);
                        obj.sheng = obj.selectedOptions[0];
                        obj.shi = obj.selectedOptions[1];
                        obj.qu = obj.selectedOptions[2];
                        obj.userid = JSON.parse(localStorage.getItem('user')).gid;
                        !obj.isdefault ? obj.isdefault=0 : obj.isdefault=1;
                        delete obj.selectedOptions;
                        if(vm.type == 0){
                            addAdress(obj).then(res => {
                                if(res.status){
                                    if(vm.changetype != '1'){
                                        vm.$message({
                                            message: "新增收货地址成功！",
                                            type: "success"
                                        });
                                        vm.$emit('submit');
                                    }else{//保存并使用地址
                                        // vm.$message({
                                        //     message: "保存并切换收货地址成功！",
                                        //     type: "success"
                                        // });
                                        vm.$emit('closeall', res.data); //关闭所有弹窗
                                    }
                                }
            
                            }).catch(err => {
            
                            }); 
                        }else{
                            updateAdress(obj).then(res => {
                                if(res.status){  
                                    if(vm.changetype != '1'){
                                        vm.$message({
                                            message: "修改收货地址成功！",
                                            type: "success"
                                        });
                                        vm.$emit('submit');
                                    }else{//保存并使用地址
                                        // vm.$message({
                                        //     message: "保存并切换收货地址成功！",
                                        //     type: "success"
                                        // });
                                        vm.$emit('closeall', res.data); //关闭所有弹窗
                                    }
                                }
            
                            }).catch(err => {
            
                            }); 
                        }       
                    }
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Components/addressForm.vue